import { normalizeLocale } from '@/i18n/localeCatalog';

/** Chuỗi cố định trong RoleDashboardShell (sidebar / topbar / drawer). */
export function getDashboardShellStrings(locale) {
  const id = normalizeLocale(locale);
  const t = (vi, en, zh) => (id === 'en' ? en : id === 'zh' ? zh : vi);
  return {
    home: t('Trang chủ', 'Home', '首页'),
    support: t('Hỗ trợ', 'Support', '支持'),
    logout: t('Đăng xuất', 'Log out', '退出登录'),
    searchPlaceholder: t('Tìm kiếm…', 'Search…', '搜索…'),
    openMenu: t('Mở menu', 'Open menu', '打开菜单'),
    closeMenu: t('Đóng', 'Close', '关闭'),
    navDialogLabel: t('Menu điều hướng', 'Navigation menu', '导航菜单'),
    closeOverlay: t('Đóng menu', 'Close menu', '关闭菜单'),
    notifications: t('Thông báo', 'Notifications', '通知'),
    noNotifications: t('Không có thông báo.', 'No notifications.', '暂无通知。'),
    expand: t('Mở rộng', 'More', '更多'),
    openNotificationsPage: t('Mở trang thông báo', 'Open notifications', '打开通知页'),
    settings: t('Cài đặt', 'Settings', '设置'),
    themeLight: t('Sáng', 'Light', '浅色'),
    themeDark: t('Tối', 'Dark', '深色'),
    themeLine: t('Giao diện:', 'Theme:', '主题：'),
    openFullSettings: t('Mở trang cài đặt đầy đủ', 'Open full settings', '打开完整设置'),
    account: t('Tài khoản', 'Account', '账户'),
    openAccountPage: t('Mở trang quản lý tài khoản', 'Open account page', '打开账户管理页'),
    langSwitch: t('Ngôn ngữ', 'Language', '语言'),
    accountFallback: t('Tài khoản', 'Account', '账户'),
    fieldId: 'ID',
    fieldName: t('Tên', 'Name', '姓名'),
    fieldEmail: 'Email',
  };
}
